export type AnalyticsConnection = {
  analytics_sync_status?: string | null;
};

export type AnalyticsSummary = {
  tracked_content: number;
  [key: string]: unknown;
};

export type AnalyticsState = 'empty' | 'importing' | 'ready' | 'stale' | 'error';

export type DeriveAnalyticsStateInput = {
  connections?: readonly AnalyticsConnection[] | null;
  summary?: AnalyticsSummary | null;
  loading: boolean;
  error: unknown | null;
};

const ERROR_STATUSES = new Set(['error', 'reconnect_required']);
const IMPORTING_STATUSES = new Set(['queued', 'running']);

export function deriveAnalyticsState({
  connections,
  summary,
  loading,
  error,
}: DeriveAnalyticsStateInput): AnalyticsState {
  const hasImportedData = summary !== null && summary !== undefined;
  const hasAccountError = connections?.some((connection) =>
    ERROR_STATUSES.has(connection.analytics_sync_status ?? ''),
  ) ?? false;

  if (error) return hasImportedData ? 'stale' : 'error';
  if (connections == null) return 'importing';
  if (connections.length === 0) return 'empty';

  if (hasImportedData && hasAccountError) return 'stale';
  if (hasImportedData) return 'ready';
  if (loading) return 'importing';
  if (hasAccountError) return 'error';
  if (connections.some((connection) => IMPORTING_STATUSES.has(connection.analytics_sync_status ?? ''))) {
    return 'importing';
  }

  return 'importing';
}
